import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function NewFolderForm({ teamId, parent, onDone }) {
  const [name, setName] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post(`/teams/${teamId}/folders`, { name, parent_folder_id: parent }); toast.success("Folder created"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">Folder name</div>
        <input data-testid="folder-name" autoFocus required value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black" placeholder="Untitled folder"/>
      </div>
      <button data-testid="folder-submit" disabled={busy} className="w-full bg-black text-white py-2.5 rounded-md disabled:opacity-50">{busy ? "Creating…" : "Create"}</button>
    </form>
  );
}
